import { useState, useRef } from "react";
import { Alert, Box, Button } from "@mui/material";
import axios from "axios";
import Loader from "../Loader";

export default function UpdateImageModal({
  asset,
  refreshAssets,
  handleCloseOne,
  handleCloseTwo,
}) {
  const url = process.env.REACT_APP_URL;
  const imageInputref = useRef();
  const [assetImage, setAssetImage] = useState("");
  const [base64Image, setBase64Image] = useState(null);
  const [fileType, setFileType] = useState("");
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleCloseOne(false);
        handleCloseTwo(false);
        refreshAssets();
      }
    }, duration);
  };

  //Clear the image from state
  const clearImage = () => {
    imageInputref.current.value = "";
    setAssetImage("");
    setBase64Image("");
    setFileType("");
  };

  const handleTakePhoto = (e) => {
    const img = e.target.files[0];
    //Will check an image has been uploaded and that it is of valid filetype - either PNG OR JPEG before allowing upload

    if (img) {
      const _fileType = img.type;
      if (_fileType !== "image/png" && _fileType !== "image/jpeg") {
        handleAlert("PNG OR JPEG files only", "warning");
        clearImage();
        return;
      }
      setFileType(_fileType);
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(img);
      setAssetImage(URL.createObjectURL(img));
    }
  };

  const handleImageUpdate = async () => {
    setLoader(true);
    const byteCharacters = atob(base64Image.split(",")[1]);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset++) {
      const byte = byteCharacters.charCodeAt(offset);
      byteArrays.push(byte);
    }

    const blob = new Blob([new Uint8Array(byteArrays)], { type: fileType });
    const reader = new FileReader();
    reader.onloadend = async () => {
      const _img = reader.result.split(",")[1];
      let reqBody = {
        currentUser: localStorage.getItem("userId"),
        currentUsername: localStorage.getItem("username"),
        assetId: asset.assetId,
        fileType: fileType,
        assetImage: _img,
        assetName: asset.assetName.trim(),
      };

      await axios
        .post(`${url}/assets/update-asset-image`, reqBody)
        .then((res) => {
          handleAlert("Asset Image successfully updated", "success", true, 500);
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
          handleAlert(`${err.response.data.message}`, "error");
          setLoader(false);
        });
    };

    reader.readAsDataURL(blob);
  };

  return (
    <Box className="update-image-modal">
      <section className="update-image-section">
        <h2>Update Asset Image</h2>
        <p>
          Click{" "}
          <a href={asset.assetImage} target="_blank">
            here
          </a>{" "}
          to see the curret asset image
        </p>
        <section className="image-upload-section">
          <label>Upload an image of the asset below</label>

          <input
            type="file"
            accept="image/png, image/jpeg"
            capture="camera"
            onChange={handleTakePhoto}
            ref={imageInputref}
          />

          {assetImage && (
            <>
              <img
                src={assetImage}
                alt="Preview"
                style={{ width: "300px", marginTop: "20px" }}
              />
              <Button color="error" onClick={clearImage}>
                Remove Image
              </Button>
            </>
          )}
        </section>
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        {!loader ? (
          <section className="btn-section">
            <Button
              color="error"
              variant="contained"
              onClick={() => handleCloseOne(false)}
              disabled={disable}
            >
              Close
            </Button>
            <Button
              color="warning"
              variant="contained"
              disabled={disable}
              onClick={handleImageUpdate}
            >
              Update
            </Button>
          </section>
        ) : (
          <Loader />
        )}
      </section>
    </Box>
  );
}
